// Module
var code = `editor de formularios `;
// Exports
module.exports = code;